import { render } from "./Subscriber.vue?vue&type=template&id=4dd9ba40&ts=true"
import script from "./Subscriber.vue?vue&type=script&lang=ts"
export * from "./Subscriber.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__